import { render, staticRenderFns } from "./NotConnected.vue?vue&type=template&id=3ea480c7&scoped=true&"
var script = {}
import style0 from "./NotConnected.vue?vue&type=style&index=0&id=3ea480c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea480c7",
  null
  
)

export default component.exports